import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { TipInterface, setEditId, setEditError, selectTipById } from "../../../store/mine_craft/tipsSlice";
import { updateTip, fetchTip } from "../../../actions/mine_craft/tipsActions";
import { objToFormData } from "../../../helpers/FormHelper";

import DrawerRight from "../../../componets/DrawerRight";
import AlertBlock from "../../../componets/AlertBlock";
import Form from './_partials/_Form';

const Edit = () => {
  const dispatch  = useAppDispatch();
  const location  = useLocation();
  const id: any   = useAppSelector(state => state.mineCraft.tips.editId);
  const error     = useAppSelector(state => state.mineCraft.tips.editError);
  const tip       = useAppSelector(state => id ? selectTipById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchTip(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    dispatch(setEditId(null));
  }, [location, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: TipInterface) {
    handleSave(data).catch(console.error);
  }

  function getLocaleRules() {
    const localeRules: any = {};

    if (tip) {
      tip.empty_locales.forEach(key => localeRules[key] = { blank: false });
    }

    return localeRules;
  }

  async function handleSave(data: TipInterface) {
    const rules         = { title_translations: getLocaleRules() };
    const formData: any = objToFormData(data, rules);
    const resultAction  = await dispatch(updateTip({ id, data: formData }));

    if (updateTip.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-tip'>
        <h6 className="v-content-label">Edit Help</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        {tip && <Form params={tip} onFinish={onFinish} />}
      </div>
    </DrawerRight>
  )
}

export default Edit;
